import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SendReportEmailRequest {
  schoolId: number;
  academicYearId: number;
  reportSlug: string;
  reportName: string;
  to: string[];
  cc?: string[];
  subject: string;
  body?: string;
  format: 'xlsx' | 'csv' | 'pdf';
  filters?: Record<string, any>;
  columns?: string[];
}

export interface SendReportEmailResponse {
  queued: boolean;
  message: string;
  correlationId?: string;
}

@Injectable({ providedIn: 'root' })
export class ReportEmailService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  send(request: SendReportEmailRequest): Observable<SendReportEmailResponse> {
    return this.http.post<SendReportEmailResponse>(this.baseUrl + 'ReportEmail/send', request);
  }
}
